import React from "react";
import popupStyles from "../../modals/privacyProtectionPopup/privacyProtectionPopup.module.css";
import { tWithKeyAttr as t } from "../../../i18nHelper";
import doctor from "../../../images/questionnaire_doctor.png";

interface IPrivacyPolicyConsentPopupProps {
  handleAccept: () => void;
}
const PrivacyPolicyConsentPopup: React.FC<IPrivacyPolicyConsentPopupProps> = ({
  handleAccept,
}: IPrivacyPolicyConsentPopupProps) => {
  return (
    <article className={popupStyles.popup} data-testid="privacy-policy-consent-popup">
      <h2 className={popupStyles.popup__title}>
        {t("PRIVACY_PROTECTION_DECLARATION")}
      </h2>
      <img
        src={doctor}
        alt={t("IMAGE_OF_VENUS")}
        className={popupStyles.popup__img}
      />
      <p className={popupStyles.popup__text}>{t("PRIVACY_COMMITMENT_GTM")}</p>

      <button
        type={"button"}
        data-testid="privacy-policy-consent-button"
        className={`button hover ${popupStyles.popup__nextBtn}`}
        onClick={handleAccept}
      >
        {t("CONTINUE_1")}
      </button>
    </article>
  );
};

export default PrivacyPolicyConsentPopup;
